import React from "react";
import { Webcam } from "../../types";
import styles from "./WebcamViewer.module.css";

interface WebcamViewerProps {
  webcam: Webcam;
  onBack: () => void;
}

export const WebcamViewer: React.FC<WebcamViewerProps> = ({
  webcam,
  onBack,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={onBack}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M10 12L6 8L10 4"
              stroke="var(--app-text-color)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h3 className={styles.title}>{webcam.name}</h3>
      </div>

      <div className={styles.videoWrapper}>
        <iframe
          src={webcam.url}
          className={styles.iframe}
          frameBorder="0"
          allowFullScreen
          title={`Веб-камера ${webcam.name}`}
        />
      </div>
    </div>
  );
};
